// extracted by mini-css-extract-plugin
var _1 = "iconBase-vIH2";
var _2 = "iconBaseNotClickable-T4ub";
export { _1 as "iconBase", _2 as "iconBaseNotClickable" }
